export default "__VITE_PUBLIC_ASSET__e8fd4a4f__"